import classNames from 'clsx';
import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import { Icon } from '@swf/sports/components';

import { TXTWCL_Close_Bet_Slip, TXTWCL_Open_Bet_Slip } from './BetSlipHeader.messages.json';
import styles from './BetSlipHeader.scss';
import BetSlipHeaderContent from './components/BetSlipHeaderContent/BetSlipHeaderContent';

const BetSlipHeader: React.FC = () => {
  const { betSlip } = useDispatch<Dispatch>();

  const isOpen = useSelector(select.betSlip.isOpen);
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.container}>
      <h2
        className={classNames(styles.header, { [styles.open]: isOpen })}
        data-testid="bet-slip-heading"
      >
        <BetSlipHeaderContent />
      </h2>
      <button
        type="button"
        onClick={() => betSlip.betSlipOpened(!isOpen)}
        className={classNames(styles.button, { [styles.open]: isOpen })}
        aria-label={
          isOpen ? formatMessage(TXTWCL_Close_Bet_Slip) : formatMessage(TXTWCL_Open_Bet_Slip)
        }
      >
        <Icon
          name="chevron-medium-up"
          className={classNames(styles.chevronIcon, { [styles.open]: isOpen })}
          size="lg"
        />
      </button>
    </div>
  );
};

export default memo(BetSlipHeader);
